/* ============================================================================
   nuud US — announcement bar
   ----------------------------------------------------------------------------
   Cross-fades the messages in the pink strip. Two things worth knowing:

   1. The markup ships with the first message already carrying `is-on`, so with
      JS off the bar is a single static message rather than a stack of
      overlapping text. This file only ever moves that class along.

   2. `aria-hidden` moves with it. Without that a screen reader reads all of
      the messages at once, including the ones nobody can see.
   ========================================================================= */
(function () {
  'use strict';

  function boot() {
    document.querySelectorAll('[data-announcement]').forEach(function (stack) {
      if (stack.dataset.announcementBound) return;

      var items = Array.prototype.slice.call(
        stack.querySelectorAll('[data-announcement-item]')
      );
      if (items.length < 2) return;

      stack.dataset.announcementBound = 'true';

      var seconds = parseInt(stack.getAttribute('data-announcement'), 10);
      if (!seconds || seconds < 3) seconds = 5;

      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-on');
        items[i].setAttribute('aria-hidden', 'true');

        i = (i + 1) % items.length;

        items[i].classList.add('is-on');
        items[i].removeAttribute('aria-hidden');
      }, seconds * 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-bind when the section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', boot);
})();
